import { ProductionLine } from '@app:types';

export type LocationsState = {
  id: string;
  name: string;
  productionLines: ProductionLine[];
};

export const initialState: LocationsState = {
  id: null!,
  name: 'Loading...',
  productionLines: [],
};
